import { configureStore } from "@reduxjs/toolkit";
import { modelReducer } from "./ModelReducer";
import { dataDescriptionReducer } from "./DataDescriptionReducer";
import { miscReducer } from "./MiscReducer";
import { viewsReducer } from "./ViewsReducer";
import { drawingReducer } from "./DrawingReducer";
import { rulesReducer } from "./RulesReducer";
import { layerReducer } from "./LayerReducer";
import { localeReducer } from "./localeReducer";

const allReducers = configureStore({
  reducer: {
    misc: miscReducer,
    model: modelReducer,
    data_description: dataDescriptionReducer,
    drawing: drawingReducer,
    views: viewsReducer,
    rules: rulesReducer,
    layers: layerReducer,
    locale: localeReducer,
  },
});

export default allReducers;
